const FETCH_TENANT_CONFIG = 'FETCH_TENANT_CONFIG'
const FETCH_CUSTOMER_TAXONOMIES_BY_PARENT_NAME = 'FETCH_CUSTOMER_TAXONOMIES_BY_PARENT_NAME'
const FETCH_SUB_TENANTS = 'FETCH_SUB_TENANTS'

export {
  FETCH_TENANT_CONFIG,
  FETCH_CUSTOMER_TAXONOMIES_BY_PARENT_NAME,
  FETCH_SUB_TENANTS
}
